<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="companyAddressAudits && companyAddressAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="companyAddressAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Company Address audits </ng-template>
</ng-template>
